<mad-button-group>
  <button matButton="outlined" madButton>Primary</button>
  <button matButton="outlined" madButton color="accent">Accent</button>
  <button matButton="outlined" madButton color="warn">Warn</button>
</mad-button-group>
<br /><br />
<mad-button-group>
  <button matButton="elevated" madButton>Day</button>
  <button matButton="elevated" madButton>Week</button>
  <button matButton="elevated" madButton>Month</button>
</mad-button-group>
